/**
 * Utility function to calculate percentage and format it.
 * @param part - The part value.
 * @param total - The total value.
 * @param decimals - The number of decimal places to format the percentage to.
 * @returns The formatted percentage as a string.
 */

import { DEFAULT_DECIMALS, cleanDecimal } from './number';

const PERCENTAGE_THRESHOLD = 0.005;
const PERCENTAGE_THRESHOLD_STRING = '~0%';
export const calcPercentage = (
  part?: number,
  total?: number,
  decimals = DEFAULT_DECIMALS,
): number | undefined => {
  if (typeof part !== 'number' || !total) return undefined;
  if (part === 0) return 0;

  const percentage = (part / total) * 100;

  return parseFloat(cleanDecimal(percentage, decimals));
};

const isLessThanThreshold = (percentage: number) =>
  percentage > 0 && percentage < PERCENTAGE_THRESHOLD;
export const calcPercentageString = (
  part: number | undefined,
  total: number,
  decimals = 2,
): string | undefined => {
  const percentage = calcPercentage(part, total, decimals);
  if (typeof percentage !== 'number') return undefined;

  if (isLessThanThreshold(percentage)) {
    return PERCENTAGE_THRESHOLD_STRING;
  }

  return `${percentage}%`;
};

export const formatPercentage = (percentage: number, decimals = DEFAULT_DECIMALS): string => {
  if (isLessThanThreshold(percentage)) {
    return PERCENTAGE_THRESHOLD_STRING;
  }

  return `${cleanDecimal(percentage, decimals)}%`;
};
